import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';

export const getState = (stateNumber) => {
  const state = {};

  switch (stateNumber) {
    default:
    case 1:
      state.icon = 'check';
      state.bgColor = '#00b050';
      state.fgColor = '#fff';
      break;
    case 2:
      state.icon = 'alert';
      state.bgColor = '#ffc000';
      state.fgColor = '#fff';
      break;
    case 3:
      state.icon = 'error-warning';
      state.bgColor = '#ff0000';
      state.fgColor = '#fff';
      break;
  }

  return state;
};
